import React, { useEffect, useState } from 'react';
import { Elements } from '@stripe/react-stripe-js';
import { loadStripe } from '@stripe/stripe-js';
import './styles.scss';
import AddNewCardForm from './AddNewCardForm';
import { IPayments } from 'interfaces/payment';

const AddPaymentModal: React.FC<IPayments.IAddNewCardProps> = props => {
  const [stripePromise, setStripePromise] = useState<ReturnType<typeof loadStripe> | null>(null);
  const { onCancel, onNewPaymentMethodAdded } = props;

  const handleSubmit = async (e: any) => {
    console.log('xx');
  };
  useEffect(() => {
    setStripePromise(loadStripe(process.env.REACT_APP_STRIPE_KEY || ''));
  }, []);

  return (
    <form onSubmit={handleSubmit} className={'main-container-payment-modal'}>
      <div className={'modal-container'}>
        <div className={'modal-header'}>
          <div>
            <div className={'label'}>Add Payments</div>
          </div>
          <i className={'fa fa-times'} onClick={()=>onCancel()} />
        </div>
        <div className={'modal-body'}>
          <Elements stripe={stripePromise}>
            <div className={`new-card-container p-3 ${props.customClass || ''}`}>
              <AddNewCardForm
                onCancel={onCancel}
                onCardAdded={onNewPaymentMethodAdded}
                customClass={props.customClass}
              />
            </div>
          </Elements>
        </div>
      </div>
    </form>
    
  );
};

export default AddPaymentModal;
